import {Button, Dropdown, Icon, MenuListItem, NavItem} from '@albert-io/atomic';
import React, {ComponentProps} from 'react';
import {Link} from 'react-router';

import './global-navigation.scss';

type AssignmentsFoldersDropdownProps = {
  linkClasses?: string;
  link: any; // Assuming 'link' is an Immutable.js Map or similar structure
  onMenuItemClick?: () => void;
  isForDrawer?: boolean;
  isMatchingRoute?: boolean;
} & Omit<ComponentProps<typeof NavItem>, 'children'>;

const AssignmentsFoldersDropdown = ({
  linkClasses,
  link,
  onMenuItemClick,
  isForDrawer,
  isMatchingRoute = false,
  ...props
}: AssignmentsFoldersDropdownProps) => {
  return (
    <Dropdown
      trigger={
        <span>
          {isForDrawer ? (
            <Button className={`${linkClasses} u-width_100`}>
              {link.get('name')}
              <Icon icon='caret-down' className='u-mar-l_1' />
            </Button>
          ) : (
            <li key={link.get('key')}>
              <NavItem {...props} as='div' icon={link.get('icon', null)} active={isMatchingRoute}>
                {link.get('name')}
                <Icon icon='caret-down' className='u-mar-l_1' />
              </NavItem>
            </li>
          )}
        </span>
      }
      position='bottom-start'
      closeOnItemClicked
      className={isForDrawer ? 'global-nav-drawer__assignments-dropdown' : ''}
    >
      <div className='u-pad_1'>
        <MenuListItem
          as={Link}
          to='/assignment-builder/create-assignment'
          className='nav-submenu_item nav-submenu_blue-item'
          onMenuItemClick={onMenuItemClick}
        >
          <Icon icon='plus' className='u-mar-r_1' />
          New Assignment
        </MenuListItem>
        <div className='nav-submenu_border-line' />
        <MenuListItem
          as={Link}
          to='/assignments'
          className='nav-submenu_item'
          onMenuItemClick={onMenuItemClick}
        >
          <Icon icon={['fal', 'file-alt']} className='nav-submenu_assignments-icon' />
          Assignments
        </MenuListItem>
        <MenuListItem
          as={Link}
          to='/saved'
          className='nav-submenu_item'
          onMenuItemClick={onMenuItemClick}
        >
          <Icon icon={['fal', 'folder-open']} className='u-mar-r_1' />
          Folders
        </MenuListItem>
      </div>
    </Dropdown>
  );
};

export default AssignmentsFoldersDropdown;
